import UserInput from "inputs/UserInput";

export default function UserFilter({ label, value, valueSet }) {
  return (
    <div style={{ margin: 5, minWidth: 150 }}>
      <UserInput label={label} size="small" value={value} onChange={valueSet} />
    </div>
  );
}
